/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminGetOrganizationResponse } from '@localstack/types';
import type { AdminPatchOrganizationRequest } from '@localstack/types';
import type { AdminPatchOrganizationResponse } from '@localstack/types';
import type { GetOrganizationResponse } from '@localstack/types';
import type { GetOrganizationStatsResponse } from '@localstack/types';
import type { PatchOrganizationRequest } from '@localstack/types';
import type { PatchOrganizationResponse } from '@localstack/types';
import type { PatchOrganizationSettingsRequest } from '@localstack/types';
import type { PatchOrganizationSettingsResponse } from '@localstack/types';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OrganizationService {
  /**
   * @returns GetOrganizationResponse
   * @throws ApiError
   */
  public static getOrganization(): CancelablePromise<GetOrganizationResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/organizations/my',
    });
  }

  /**
   * @param requestBody
   * @returns PatchOrganizationResponse
   * @throws ApiError
   */
  public static patchOrganization(requestBody: PatchOrganizationRequest): CancelablePromise<PatchOrganizationResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/organizations/my',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns GetOrganizationStatsResponse
   * @throws ApiError
   */
  public static getOrganizationStats(): CancelablePromise<GetOrganizationStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/organizations/my/stats',
    });
  }

  /**
   * @param requestBody
   * @returns PatchOrganizationSettingsResponse
   * @throws ApiError
   */
  public static patchOrganizationSettings(
    requestBody: PatchOrganizationSettingsRequest,
  ): CancelablePromise<PatchOrganizationSettingsResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/organizations/my/settings',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param orgId
   * @returns AdminGetOrganizationResponse
   * @throws ApiError
   */
  public static adminGetOrganization(orgId: string): CancelablePromise<AdminGetOrganizationResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/admin/orgs/{org_id}',
      path: {
        org_id: orgId,
      },
    });
  }

  /**
   * @param orgId
   * @param requestBody
   * @returns AdminPatchOrganizationResponse
   * @throws ApiError
   */
  public static adminPatchOrganization(
    orgId: string,
    requestBody: AdminPatchOrganizationRequest,
  ): CancelablePromise<AdminPatchOrganizationResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/admin/orgs/{org_id}',
      path: {
        org_id: orgId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
